import { Pipe, PipeTransform } from '@angular/core';
import { format, parse } from 'date-fns';
import { es } from 'date-fns/locale';

@Pipe({
  name: 'PCustomDayFormat'
})
export class CustomDayFormatPipe implements PipeTransform {

  transform(value: string): string {
    const date = parse(value, "dd-MM-yyyy", new Date(), {
      locale: es
    });
    const formattedDate = format(date, "dd 'de' MMMM 'del' yyyy", { locale: es });

    return formattedDate;
  }

}
